import { jsxs as d, jsx as i } from "@emotion/react/jsx-runtime";
import { styled as a, Box as t, Divider as s } from "@mui/material";
const o = a(t)(({ theme: e }) => ({
  height: "100%",
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  paddingInline: e.spacing(3)
})), m = ({ logo: e, sx: r = [] }) => /* @__PURE__ */ d(t, { width: "100%", height: { xs: "3.5rem", md: "5rem" }, children: [
  /* @__PURE__ */ i(o, { sx: [...Array.isArray(r) ? r : [r]], "aria-hidden": "true", children: e }),
  /* @__PURE__ */ i(
    s,
    {
      "aria-hidden": "true",
      sx: (n) => ({
        [n.breakpoints.down("md")]: {
          display: "none"
        }
      })
    }
  )
] });
export {
  m as H
};
